class AmzProductPage {
  constructor() {
    this.initAccordion();
    this.initGallery();
  }

  /* =========================
     Accordion
  ========================= */
  initAccordion() {
    const container = document.querySelector('.section-amz-accordion');

    if (!container) return;

    container.addEventListener('click', (e) => {
      const header = e.target.closest('.accordion-header');

      if (!header || !container.contains(header)) return;

      const body = header.nextElementSibling;

      if (!body || !body.classList.contains('accordion-body')) return;

      const isOpen = body.classList.contains('open');

      // Close all
      container.querySelectorAll('.accordion-header').forEach((h) => {
        h.classList.remove('open');

        const b = h.nextElementSibling;

        if (b) b.classList.remove('open');
      });

      // Open selected
      if (!isOpen) {
        header.classList.add('open');
        body.classList.add('open');
      }
    });
  }

  /* =========================
     Product Gallery
  ========================= */
  initGallery() {
    document.querySelectorAll('.product_gallery').forEach((wrapper) => {
      const thumbs = wrapper.querySelectorAll('.gallery-thumb');
      const slides = wrapper.querySelectorAll('.gallery-main__slide');

      thumbs.forEach((thumb) => {

        const activate = () => this.activateGalleryItem(thumb.dataset.index, thumbs, slides);

        ['click', 'mouseenter'].forEach(event =>
          thumb.addEventListener(event, activate)
        );

        thumb.addEventListener('keydown', (e) => {
          if (['Enter', ' '].includes(e.key)) activate();
        });
        
      });
    });
  }

  activateGalleryItem(index, thumbs, slides) {
    // Remove active classes
    thumbs.forEach((t) => t.classList.remove('is-active'));
    slides.forEach((s) => s.classList.remove('is-active'));

    // Find active items
    const activeThumb = [...thumbs].find((t) => t.dataset.index === index);
    const activeSlide = [...slides].find((s) => s.dataset.index === index);

    // Add active classes
    if (activeThumb) activeThumb.classList.add('is-active');
    if (activeSlide) activeSlide.classList.add('is-active');

    // ── Sync product-featured-media class for zoom JS ──
    slides.forEach((s) => s.querySelector('img')?.classList.remove('product-featured-media'));
    if (activeSlide) activeSlide.querySelector('img')?.classList.add('product-featured-media');
    }
}

document.addEventListener('DOMContentLoaded', () => {
  new AmzProductPage();
});